/**
 * Utility functions.
 */

/* global pym */
'use strict';

// Dependencies
import queryString from 'query-string';
import _ from 'underscore';


// Util class
class Util {
  constructor(options) {
    this.options = options;

    // Defaults
    this.options.pym = this.options.pym === undefined ? true : this.options.pym;

    // Read in query params
    this.parseQuery();

    // Enable pym
    if (this.options.pym) {
      this.pym = !_.isUndefined(window.pym) ? new pym.Child({ polling: 500 }) : undefined;
    }
  }

  // Get query params and adjust as needed
  parseQuery() {
    this.query = queryString.parse(document.location.search);

    // Adjust options
    if (this.query.pym && this.query.pym === 'true') {
      this.options.pym = true;
    }
  }

  // Super basic deep clone
  deepClone(data) {
    return JSON.parse(JSON.stringify(data));
  }

  // Check whether embedded
  isEmbedded() {
    if (!_.isUndefined(this.embedded)) {
      return this.embedded;
    }

    try {
      this.embedded = window.self !== window.top;
    }
    catch(e) {
      this.embedded = true;
    }

    return this.embedded;
  }

  // Check if local storage is available
  hasLocalStorage() {
    if (!_.isUndefined(this.localStorage)) {
      return this.localStorage;
    }

    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      this.localStorage = true;
    }
    catch(e) {
      this.localStorage = false;
    }

    return this.localStorage;
  }

  // Format moment date in AP style: Dec. 23, 2014
  dateFormatAP(m) {
    if (!_.isObject(m)) {
      return '';
    }

    // The issue is that the AP style has odd issues with month
    //  'Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'
    if (![2, 3, 4, 5, 6].indexOf(m.month())) {
      return m.format('MMMM D, YYYY');
    }
    else {
      return m.format('MMM. D, YYYY');
    }
  }

  // Format moment time in AP style: 5:32 p.m. EST
  timeFormatAP(m) {
    if (!_.isObject(m)) {
      return '';
    }

    // Moment doesn't have a.m.
    return m.format('h:mm') +
      ((m.format('a') === 'am') ? ' a.m. ' : ' p.m. ') +
      m.format('zz');
  }
}

// Export a generator for the class.
export default (options) => {
  return new Util(options);
};



// WEBPACK FOOTER //
// ./app/utils.js